module.exports = __webpack_public_path__ + "img/101.35559232.svg";